import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-desktop-row.css";
import { Link, withRouter } from "react-router-dom";
import CellWithTwoLabels from "../shared/groups/CellWithTwoLabels";

import { connect } from "react-redux";
import { setClaimDetailsForClaim } from "../../actions/claims/claimsActions";

const mapDispatchToProps = dispatch => {
  return {
    setClaimDetailsForClaim: (claimReference, securityId, history) =>
      dispatch(setClaimDetailsForClaim(claimReference, securityId, history))
  };
};

class ClaimsSummaryDesktopRow extends Component {
  constructor(props) {
    super(props);
    this.claimDetailsOnClickHandler = this.claimDetailsOnClickHandler.bind(
      this
    );
  }

  async claimDetailsOnClickHandler() {
    await this.props.setClaimDetailsForClaim(
      this.props.claimSummary.ClaimNumber,
      this.props.claimSummary.MemberId,
      this.props.history
    );
  }

  render() {
    return (
      <React.Fragment>
        <div
          className={"col-1 " + style.paddingRightForIcon}
          onClick={this.claimDetailsOnClickHandler}
          onKeyPress={this.claimDetailsOnClickHandler}
        >
          <i
            className={
              "icon-functional-document " +
              style.claimRowIcon +
              " " +
              style.floatIconRight
            }
          />
        </div>
        <div
          className={"col-4 " + style.formatAsClickableLink}
          onClick={this.claimDetailsOnClickHandler}
          onKeyPress={this.claimDetailsOnClickHandler}
        >
          <CellWithTwoLabels
            topLabel={this.props.claimSummary.ClaimNumber}
            bottomLabel={this.props.claimSummary.ClaimCondition}
          />
        </div>

        <div className="col">
        <CellWithTwoLabels
             topLabel={"Date notified: " + this.props.claimSummary.DateNotified}
            
             bottomLabel={
              this.props.claimSummary.ClaimCondition === "Optical Care" ||
                this.props.claimSummary.ClaimCondition === "Dental Care" ||
                this.props.claimSummary.ClaimCondition === "Doctor@Hand" ||
                this.props.claimSummary.ClaimCondition === "Private GP Fees" ||
                this.props.claimSummary.ClaimCondition === "Health Assessment" ||
                this.props.claimSummary.ClaimCondition === "Vaccinations" ||
                this.props.claimSummary.ClaimCondition === "Accidental Death"
                ?
                null : "Claim status: " + this.props.claimSummary.ClaimSubStatus
             }
          />
        </div>
        <div className={style.viewClaimLink + " col text-right"}>
          <Link
            to="#"
            onClick={() => this.claimDetailsOnClickHandler()}
            aria-label={`View claim ${this.props.claimSummary.ClaimNumber}`}
          >
            View claim <span className="ml-2">➔</span>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(null, mapDispatchToProps)(ClaimsSummaryDesktopRow)
);
